import { securityKeys } from "../enums/SecurityKeys.ENUM";

export const generalMenuItems = [
    {
        section: "General",
        items: [
            {
                id: 1,
                title: "Dashboard",
                icon: "pi pi-th-large",
                path: "/",
                securityKey: securityKeys.DASHBOARD ?? "Dashboard"
            },
            {
                id: 2,
                title: "Job Requisition",
                icon: "pi pi-briefcase",
                path: "/job-requisition",
                securityKey: securityKeys.JOB_REQUISITION ?? "Job Requisition"
            },
            {
                id: 3,
                title: "Skill Configuration",
                icon: "pi pi-sliders-h",
                securityKey: securityKeys.SKILL_CONFIGURATION ?? "Skill Configuration",
                subMenu: [
                    {
                        title: "Skill Category",
                        icon: "pi pi-slack",
                        path: "/skill-category",
                        securityKey: securityKeys.SKILL_CATEGORIES ?? "Skill Categories",
                    },
                    {
                        title: "Skills",
                        icon: "pi pi-sitemap",
                        path: "/skills",
                        securityKey: securityKeys.SKILL_MANAGEMENT ?? "Skill Management",
                    },
                ],
            },
            {
                id: 4,
                title: "Manage Questions",
                icon: "pi pi-question-circle",
                securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                subMenu: [
                    {
                        title: "Question List",
                        icon: "pi pi-list",
                        path: "/questions",
                        securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                    },
                ],
            },
        ],
    },
    {
        section: "Human Resource",
        items: [
            {
                id: 5,
                title: "HR Management",
                icon: "pi pi-users",
                securityKey: securityKeys.HUMAN_RESOURCE ?? "Human Resource",
                subMenu: [
                    {
                        title: "Applicants",
                        icon: "pi pi-id-card",
                        path: "/applicants",
                        securityKey: securityKeys.APPLICANT ?? "Applicant",
                    },
                    {
                        title: "Follow-Up Candidates",
                        icon: "pi pi-user-edit",
                        path: "/candidates/follow-up",
                        securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                    },
                    {
                        title: "Schedule Interview",
                        icon: "pi pi-calendar-plus",
                        path: "/interviews/schedule",
                        securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                    },
                    {
                        title: "Interview Workflow",
                        icon: "pi pi-calendar-plus",
                        path: "/interview-workflow",
                        securityKey: securityKeys.DASHBOARD ?? "Interview Workflow",
                    },
                ],
            },
            {
                id: 6,
                title: "Interviews",
                icon: "pi pi-calendar-clock",
                securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                subMenu: [
                    {
                        title: "Scheduled Interviews",
                        icon: "pi pi-id-card",
                        path: "/applicants",
                        securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                    },
                    {
                        title: "Completed Interviews",
                        icon: "pi pi-id-card",
                        path: "/applicants",
                        securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                    },
                ],
            },
        ]
    }
];

export const adminMenuItems = [
    {
        section: "Organization",
        items: [
            {
                id: 7,
                title: "Manage Organization",
                icon: "pi pi-building",
                // path: "/organizations",
                path: "/organization-details/:id",
                securityKey: securityKeys.MANAGE_ORGANIZATION ?? "Manage Organization",
            },
        ]
    },
    {
        section: "System",
        items: [
            {
                id: 8,
                title: "System Configuration",
                icon: "pi pi-cog",
                securityKey: securityKeys.SYSTEM_CONFIGURATION ?? "System Configuration",
                subMenu: [
                    {
                        title: "Interview Round",
                        icon: "pi pi-users",
                        path: "/interview-round",
                        securityKey: securityKeys.INTERVIEW_ROUND ?? "Interview Round",
                    },
                    {
                        title: "Interview Type",
                        icon: "pi pi-list",
                        path: "/interview-type",
                        securityKey: securityKeys.INTERVIEW_TYPE ?? "Interview Type",
                    },
                    {
                        title: "Job Openings",
                        icon: "pi pi-briefcase",
                        path: "/job-opening",
                        securityKey: securityKeys.JOB_OPENINGS ?? "Job Openings",
                    },
                    {
                        title: "Rejected Reason",
                        icon: "pi pi-times",
                        path: "/rejected-reason",
                        securityKey: securityKeys.REJECTED_REASON ?? "Rejected Reason",
                    },
                    {
                        title: "Followup Reason",
                        icon: "pi pi-refresh",
                        path: "/followup-reason",
                        securityKey: securityKeys.FOLLOWUP_REASON ?? "Followup Reason",
                    },
                    {
                        title: "Employment Types",
                        icon: "pi pi-slack",
                        path: "/employment-types",
                        securityKey: securityKeys.EMPLOYMENT_TYPES ?? "Employment Types",
                    },
                ],
            },
            {
                id: 9,
                title: "Management",
                icon: "pi pi-briefcase",
                securityKey: securityKeys.MANAGEMENT ?? "Management",
                subMenu: [
                    {
                        title: "Users",
                        icon: "pi pi-user",
                        path: "/users",
                        securityKey: securityKeys.MANAGE_USERS ?? "Manage Users",
                    },
                    {
                        title: "Roles",
                        icon: "pi pi-shield",
                        path: "/roles",
                        securityKey: securityKeys.MANAGE_ROLES ?? "Manage Roles",
                    },
                    {
                        title: "Email Template",
                        icon: "pi pi-envelope",
                        path: "/email-template",
                        securityKey: securityKeys.MANAGE_EMAIL_TEMPLATE ?? "Manage Email Template",
                    },
                    {
                        title: "System Actions",
                        icon: "pi pi-box",
                        path: "/system-actions",
                        securityKey: securityKeys.DASHBOARD ?? "Dashboard",
                    },
                    {
                        title: "Applicant Status",
                        icon: "pi pi-exclamation-circle",
                        path: "/applicant-status",
                        securityKey: securityKeys.MANAGE_APPLICANT_STATUS ?? "Manage Applicant Status",
                    },
                    {
                        title: "Channels",
                        icon: "pi pi-globe",
                        path: "/channel",
                        securityKey: securityKeys.MANAGE_CHANNEL ?? "Manage Channel",
                    },
                    {
                        title: "Sources",
                        icon: "pi pi-slack",
                        path: "/source",
                        securityKey: securityKeys.MANAGE_SOURCE ?? "Manage Source",
                    },
                    {
                        title: "Departments",
                        icon: "pi pi-sitemap",
                        path: "/department",
                        securityKey: securityKeys.MANAGE_DEPARTMENTS ?? "Manage Departments",
                    },
                ],
            },
            {
                id: 10,
                title: "Security",
                icon: "pi pi-shield",
                path: "/security",
                securityKey: securityKeys.SECURITY ?? "Security",
            },
        ],
    },
    {
        section: "Reports & Extracts",
        items: [
            {
                id: 11,
                title: "Reports",
                icon: "pi pi-chart-bar",
                securityKey: securityKeys.REPORTS ?? "Reports",
                subMenu: [
                    {
                        title: "Candidate Report",
                        icon: "pi pi-id-card",
                        path: "/candidate-reports",
                        securityKey: securityKeys.REPORTS ?? "Reports",
                    },
                    {
                        title: "Job Report",
                        icon: "pi pi-briefcase",
                        path: "/job-reports",
                        securityKey: securityKeys.REPORTS ?? "Reports",
                    },
                    {
                        title: "Activity Log Report",
                        icon: "pi pi-history",
                        path: "/activity-log-reports",
                        securityKey: securityKeys.REPORTS ?? "Reports",
                    },
                ],
            },
        ]
    },
];